import { render, staticRenderFns } from "./CategoryGroupSelector.vue?vue&type=template&id=8a4c898c"
import script from "./CategoryGroupSelector.vue?vue&type=script&lang=js"
export * from "./CategoryGroupSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports